import { API } from "aws-amplify";

export function getStats(engine, metal, fromts, tots) {
  if (metal) {
    return API.get(
      "results",
      `stats?engine=${engine}&metal=${metal}&from=${fromts}&to=${tots}`
    );
  } else {
    return API.get(
      "results",
      `stats?engine=${engine}&from=${fromts}&to=${tots}`
    );
  }
}

export function findEntities(text, limit = 20) {
  return API.get("results", `entities?name=${text}&limit=${limit}`);
}

export function entityHistory(entity, fromDate, toDate) {
  return API.get(
    "results",
    `entityhistory?entity=${entity}&from=${fromDate}&to=${toDate}`
  );
}
